// ドキュメントが読み込まれた後にページを一番上にスクロールする
$(document).ready(function () {
    $('html, body').scrollTop(0);
});

